import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import MetaTags from "react-meta-tags";
import { withRouter, Link } from "react-router-dom";
import { Tooltip } from "@material-ui/core";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Button,
  Modal,
  ModalHeader,
  ModalFooter,
  ModalBody,
} from "reactstrap";
import { isEmpty } from "lodash";

import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";
import moment from "moment";

import ToolkitProvider from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import debounce from "lodash/debounce";
import "assets/scss/table.scss";

import Breadcrumbs from "components/Common/Breadcrumb";
import { getSchemeAnalytesList } from "store/results/actions";
import { getResultSubmit } from "store/resultsSubmit/actions";
import { getMicroStatisticsList } from "store/results/actions";
import { updateRoundList } from "store/rounds/actions";
import "assets/scss/table.scss";

class Results extends Component {
  constructor(props) {
    super(props);
    this.node = React.createRef();
    this.state = {
      SchemeAnalytesList: [],
      buttonText: "Calculate",
      ResultSubmit: [],
      Statistics: [],
      antibiotic: "",
      Antibiotic: [],
      antibioticValue: 0,
      combinedData: [], // Store the combined data here
      // analyte: "",
      // rounds: [],
      isCalculated: false, // Flag to track calculation status
      successMessage: "",
      modal: false, // Modal state for visibility control
      user_id: localStorage.getItem("authUser")
        ? JSON.parse(localStorage.getItem("authUser")).user_id
        : "",
      organismList: [
        {
          text: "Organism",
          dataField: "organism",
          sort: true,
          headerStyle: { backgroundColor: "#a6d4ff", textAlign: "center" },
          align: "left",
        },
        {
          text: "Correct",
          dataField: "organism_count", // <- use this field
          sort: true,
          headerStyle: { backgroundColor: "#a6d4ff", textAlign: "center" },
          align: "center",
        },

        {
          text: "Wrong",
          dataField: "wrong",
          sort: true,
          headerAlign: "center",
          headerStyle: { backgroundColor: "#a6d4ff", textAlign: "center" },
          align: "center",
        },
      ],

      columnsList: [
        {
          text: "Antibiotic",
          dataField: "antibiotic",
          sort: true,
          headerStyle: { backgroundColor: "#a6d4ff", textAlign: "center" },
          align: "left",
        },
        {
          text: "N",
          dataField: "submitted_labs", // <- use this field
          sort: true,
          headerStyle: { backgroundColor: "#a6d4ff", textAlign: "center" },
          align: "center",
          formatter: (cell, row) => row.total_participants - row.not_submitted,
        },

        {
          text: "Expected Value",
          dataField: "expected_value",
          sort: true,
          headerAlign: "center",
          headerStyle: { backgroundColor: "#a6d4ff", textAlign: "center" },
          align: "center",
        },
        {
          text: "Correct",
          dataField: "correct",
          sort: true,
          headerAlign: "center",
          headerStyle: { backgroundColor: "#a6d4ff", textAlign: "center" },
          align: "center",
        },
        {
          text: "Wrong",
          dataField: "wrong",
          sort: true,
          headerAlign: "center",
          headerStyle: { backgroundColor: "#a6d4ff", textAlign: "center" },
          align: "center",
        },
        {
          text: "Not Submitted",
          dataField: "not_submitted",
          sort: true,
          headerAlign: "center",
          headerStyle: { backgroundColor: "#a6d4ff", textAlign: "center" },
          align: "center",
        },
      ],
    };
  }
  combineData = (analytes, results) => {
    return analytes.map(analyte => {
      const resultEntry = results.find(result => result.analyte === analyte.id);
      console.log("MATCHED ENTRY FOR:", analyte.name, resultEntry); // ✅ add this
      return {
        ...analyte,
        lab_count: resultEntry?.lab_count || 0,
        correct: resultEntry?.correct || 0,
        wrong: resultEntry?.wrong || 0,
        not_submitted: resultEntry?.not_submitted || 0,
      };
    });
  };

  isAllFieldsZero = data => {
    // Check if all the relevant fields in the data are equal to 0
    return data.every(
      item =>
        item.lab_count === 0 &&
        item.correct === 0 &&
        item.wrong === 0 &&
        item.not_submitted === 0
    );
  };

  componentDidMount() {
    const { onGetSchemeAnalyte } = this.props;
    const id = this.props.match.params.id;

    // ✅ Only fetch scheme analytes on load
    onGetSchemeAnalyte(id);
  }
  componentDidUpdate(prevProps) {
    const { Statistics } = this.props;

    if (
      Statistics !== prevProps.Statistics &&
      !isEmpty(Statistics) &&
      !isEmpty(Statistics.statistics)
    ) {
      console.log("🔄 New Statistics received:", Statistics);

      // Organism rows
      const organismRows = Statistics.statistics.map((row, idx) => ({
        id: idx + 1,
        organism: row.organism,
        organism_count: row.organism_count, // ✅ use directly from API
        correct: row.correct, // ✅ use API’s aggregated count
        wrong: row.wrong, // ✅ use API’s aggregated count
        not_submitted: row.not_submitted, // ✅ use API’s aggregated count
        total_participants: row.total_participants, // ✅ use API
      }));

      // Antibiotic rows (flattened)
      const antibioticRows = Statistics.statistics.flatMap((row, idx) =>
        row.antibiotics.map((ab, j) => ({
          id: `${idx + 1}-${j + 1}`,
          organism: row.organism,
          organism_count: row.organism_count,
          ...ab,
        }))
      );

      console.log("📋 Organism rows:", organismRows);
      console.log("📋 Antibiotic rows:", antibioticRows);

      this.setState({
        organismData: organismRows,
        antibioticData: antibioticRows,
      });
    }
  }

  onPaginationPageChange = page => {
    if (
      this.node &&
      this.node.current &&
      this.node.current.props &&
      this.node.current.props.pagination &&
      this.node.current.props.pagination.options
    ) {
      this.node.current.props.pagination.options.onPageChange(page);
    }
  };
  handleCalculate = async () => {
    const { onGetStatisticsList, onUpdateRound } = this.props;
    const id = this.props.match.params.id;

    console.log("📌 handleCalculate triggered for Round ID:", id);

    // ✅ Fetch statistics only when Calculate is clicked
    onGetStatisticsList(id);

    // ✅ Update round status
    const updatedRound = { status: "Close", added_by: this.state.user_id };
    this.props.onUpdateRound(id, updatedRound);

    // ✅ Show table
    this.setState({ isCalculated: true });

    this.displaySuccessMessage("Statistics calculated and status updated!");
  };
  handleReport = round => {
    if (round && round.id) {
      // Update the round's status to "report available"
      const updatedRound = {
        ...round,
        status: "Report Available",
        added_by: this.state.user_id,
      };

      // Dispatch the update action to save the new status
      this.props.onUpdateRound(round.id, updatedRound);
      this.displaySuccessMessage("Round Status is changed to Report Available");
    }
  };
  // Function to display the success message
  displaySuccessMessage = message => {
    this.setState({ successMessage: message, modal: true }); // Open the modal

    setTimeout(() => {
      this.setState({ successMessage: "", modal: false }); // Close the modal after 2 seconds
    }, 3000);
  };

  render() {
    // };
    const {
      closing_date,
      rounds,
      scheme_name,
      scheme_type,
      cycle_no,
      round_issuedate,
      round_status,
    } = this.props;

    const { combinedData } = this.state; // Use the combined data
    const pageOptions = {
      sizePerPage: 10,
      totalSize: combinedData.length, // Adjust totalSize for combined data
      custom: true,
    };

    const defaultSorted = [
      {
        dataField: "analyte_name",
        order: "desc",
      },
    ];
    const { issue_date } = this.props;
    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>Statistics | NEQAS</title>
          </MetaTags>
          <Container fluid>
            <Row
              className="mb-3 justify-content-start"
              style={{ marginLeft: "120px" }}
            >
              <Col>
                <Row className="mb-3" style={{ marginLeft: "80px" }}>
                  {/* First Button: Add Values */}
                  <Col md={2}>
                    <Col md={12}>
                      <Tooltip
                        title="Please assign values before calculating"
                        placement="top"
                      >
                        <span>
                          <Button
                            color="primary"
                            onClick={() => this.handleCalculate()}
                            className="w-100"
                          >
                            {this.state.buttonText}
                          </Button>
                        </span>
                      </Tooltip>
                    </Col>
                  </Col>
                  <Col md={2}></Col>
                  <Col md={2}></Col>
                  <Col md={2}></Col>
                  {scheme_type === "Identification" && (
                    <Col md={2}>
                      <Link
                        to={`/${this.state.organization_name}/microReportValue/${this.props.match.params.id}`}
                      >
                        <Button color="primary" className="w-100">
                          Assign Values
                        </Button>
                      </Link>
                    </Col>
                  )}
                  <Col md={2}>
                    <Link
                      to={`/${this.state.organization_name}/microsummaryresult/${this.props.match.params.id}`}
                    >
                      <Button color="primary" className="w-100">
                        Microsummary Result
                      </Button>
                    </Link>
                  </Col>

                  <Col md={2}></Col>
                </Row>

                {/* Show the "Report" button only when the button text is "Recalculate" */}
                {/* {this.state.buttonText === "Recalculate" && (
                  <Button
                    color="secondary"
                    onClick={() => this.handleReport(issue_date)}
                    className=""
                  >
                    Report
                  </Button>
                )} */}
              </Col>
            </Row>

            {/* Modal for displaying success message */}
            <Modal
              isOpen={this.state.modal}
              toggle={() => this.setState({ modal: !this.state.modal })}
            >
              <ModalHeader
                toggle={() => this.setState({ modal: !this.state.modal })}
              >
                Success
              </ModalHeader>
              <ModalBody>{this.state.successMessage}</ModalBody>
              <ModalFooter>
                <Button
                  color="primary"
                  onClick={() => this.setState({ modal: false })}
                >
                  OK
                </Button>
              </ModalFooter>
            </Modal>

            <div className="container">
              <Row className="mb-4">
                <Col md={3}>
                  <div className="d-flex align-items-center">
                    <span className="me-2">Round:</span>
                    <span>
                      <strong>{rounds ? rounds : "N/A"}</strong>
                    </span>
                  </div>
                </Col>
                <Col md={3}>
                  <div className="d-flex align-items-center">
                    <span className="me-2">Scheme Name:</span>
                    <span>
                      <strong>{scheme_name ? scheme_name : "N/A"}</strong>
                    </span>
                  </div>
                </Col>
                <Col md={3}>
                  <div className="d-flex align-items-center">
                    <span className="me-2">Scheme Type:</span>
                    <span>
                      <strong>{scheme_type ? scheme_type : "N/A"}</strong>
                    </span>
                  </div>
                </Col>
                <Col md={3}>
                  <div className="d-flex align-items-center">
                    <span className="me-2">Cycle No:</span>
                    <span>
                      <strong>{cycle_no ? cycle_no : "N/A"}</strong>
                    </span>
                  </div>
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md={3}>
                  <div className="d-flex align-items-center">
                    <span className="me-2">Closing Date:</span>
                    <span>
                      <strong>
                        {closing_date
                          ? moment(closing_date).format("DD-MMM-YY, h:mm A")
                          : "N/A"}
                      </strong>
                    </span>
                  </div>
                </Col>

                <Col md={3}>
                  <div className="d-flex align-items-center">
                    <span className="me-2">Issued Date:</span>
                    <span>
                      <strong>
                        {round_issuedate
                          ? moment(round_issuedate).format(
                              "DD-MMM-YY, h:mm A"
                            )
                          : "N/A"}
                      </strong>
                    </span>
                  </div>
                </Col>
                <Col md={3}>
                  <div className="d-flex align-items-center">
                    <span className="me-2">Status:</span>
                    <span>
                      <strong>{round_status ? round_status : "N/A"}</strong>
                    </span>
                  </div>
                </Col>
              </Row>
            </div>

            <Row className="justify-content-center align-item-center">
              <Col lg="10">
                <Card>
                  <CardBody>
                    <PaginationProvider
                      pagination={paginationFactory(pageOptions)}
                      keyField="id"
                      columns={this.state.organismList}
                      data={this.state.organismData || []}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <ToolkitProvider
                          keyField="id"
                          columns={this.state.organismList}
                          data={this.state.organismData || []}
                          search
                        >
                          {toolkitprops => (
                            <React.Fragment>
                              <div className="table-responsive">
                                <BootstrapTable
                                  id="printable-table"
                                  keyField="id"
                                  ref={this.node}
                                  responsive
                                  bordered={false}
                                  striped={false}
                                  defaultSorted={defaultSorted}
                                  classes={"table table-bordered table-hover"}
                                  {...toolkitprops.baseProps}
                                  {...paginationTableProps}
                                />
                                <div className="float-end">
                                  <PaginationListStandalone
                                    {...paginationProps}
                                    onPageChange={this.onPaginationPageChange}
                                  />
                                </div>
                              </div>
                            </React.Fragment>
                          )}
                        </ToolkitProvider>
                      )}
                    </PaginationProvider>
                  </CardBody>
                </Card>
              </Col>
              <Col lg="10">
                <Card>
                  <CardBody>
                    <PaginationProvider
                      pagination={paginationFactory(pageOptions)}
                      keyField="id"
                      columns={this.state.columnsList}
                      data={this.state.antibioticData || []}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <ToolkitProvider
                          keyField="id"
                          columns={this.state.columnsList}
                          data={this.state.antibioticData || []}
                          search
                        >
                          {toolkitprops => (
                            <React.Fragment>
                              <div className="table-responsive">
                                <BootstrapTable
                                  id="printable-table"
                                  keyField="id"
                                  ref={this.node}
                                  responsive
                                  bordered={false}
                                  striped={false}
                                  defaultSorted={defaultSorted}
                                  classes={"table table-bordered table-hover"}
                                  {...toolkitprops.baseProps}
                                  {...paginationTableProps}
                                />
                                <div className="float-end">
                                  <PaginationListStandalone
                                    {...paginationProps}
                                    onPageChange={this.onPaginationPageChange}
                                  />
                                </div>
                              </div>
                            </React.Fragment>
                          )}
                        </ToolkitProvider>
                      )}
                    </PaginationProvider>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

Results.propTypes = {
  match: PropTypes.object,
  className: PropTypes.any,
  SchemeAnalytesList: PropTypes.array,
  ResultSubmit: PropTypes.array,
  Statistics: PropTypes.object,
  rounds: PropTypes.string,
  issue_date: PropTypes.object,
  scheme_name: PropTypes.string,
  scheme_type: PropTypes.string,
  rounds: PropTypes.string,
  closing_date: PropTypes.string,
  round_issuedate: PropTypes.string,
  round_status: PropTypes.string,
  cycle_no: PropTypes.string,
  ListAntibiotic: PropTypes.array,
  // closing_date: PropTypes.string,
  onGetSchemeAnalyte: PropTypes.func,
  onGetResultSubmit: PropTypes.func,
  onGetStatisticsList: PropTypes.func,
  onUpdateRound: PropTypes.func,
};
const mapStateToProps = ({ SchemeAnalytesList, ResultSubmit }) => ({
  SchemeAnalytesList: SchemeAnalytesList.SchemeAnalytesList,
  ResultSubmit: ResultSubmit.ResultSubmit,
  rounds: SchemeAnalytesList.rounds,
  rounds_instance: SchemeAnalytesList.rounds_instance,
  closing_date: SchemeAnalytesList.closing_date,

  // ✅ Statistics is inside SchemeAnalytesList reducer
  Statistics: SchemeAnalytesList.Statistics,

  scheme_name: SchemeAnalytesList.schemeName,
  scheme_type: SchemeAnalytesList.schemeType,
  round_issuedate: SchemeAnalytesList.issue_date,
  round_status: SchemeAnalytesList.round_status,
  cycle_no: SchemeAnalytesList.cycle_no,
});

const mapDispatchToProps = dispatch => ({
  onGetSchemeAnalyte: id => dispatch(getSchemeAnalytesList(id)),
  onGetResultSubmit: id => dispatch(getResultSubmit(id)),
  onGetStatisticsList: id => dispatch(getMicroStatisticsList(id)),
  onUpdateRound: (id, round) => dispatch(updateRoundList({ id, ...round })),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Results));
